import { TrueBlueFormTypes } from './from-trueblue.types';

export const sendFormDataStart = (formData) => ({
  type: TrueBlueFormTypes.SEND_FORM_DATA_START,
  payload: formData,
});

export const sendFormDataSuccess = () => ({
  type: TrueBlueFormTypes.SEND_FORM_DATA_SUCCESS,
});

export const sendFormDataFailure = () => ({
  type: TrueBlueFormTypes.SEND_FORM_DATA_FAILURE,
});
